import { render } from "./survey_question.vue?vue&type=template&id=05e0e700&scoped=true"
import script from "./survey_question.vue?vue&type=script&lang=js"
export * from "./survey_question.vue?vue&type=script&lang=js"

import "./survey_question.vue?vue&type=style&index=0&id=05e0e700&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e0e700"]])

export default __exports__